let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eXOVv")).then(() => parcelRequire('g7YcF'));